import { ScrollDispatcher } from '@angular/cdk/overlay';
import { Directive, HostBinding, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { distinctUntilChanged, filter, map, takeWhile } from 'rxjs/operators';

@Directive({
  selector: '[noShadowOnBottom]',
  standalone: false,
})
export class NoShadowOnBottomDirective implements OnInit, OnDestroy {
  @Input('noShadowOnBottom') disabled = false;
  alive = true;

  @HostBinding('class.shadow') elevated = false;

  constructor(private zone: NgZone, private scrollService: ScrollDispatcher) {}

  shouldElevate(): boolean {
    if (!document) return true;
    const containerHeight: number = document.documentElement.scrollHeight;
    const scrollTop: number = document.documentElement.scrollTop;
    const windowHeight: number = window && window.innerHeight;
    return scrollTop + windowHeight !== containerHeight;
  }

  ngOnInit() {
    this.scrollService
      .scrolled(0)
      .pipe(
        filter(() => !this.disabled),
        map(this.shouldElevate),
        distinctUntilChanged(),
        takeWhile(() => this.alive)
      )
      .subscribe((isElevated: boolean) => this.zone.run(() => (this.elevated = isElevated)));

    setTimeout(() => {
      this.elevated = this.shouldElevate();
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
